module.exports = __webpack_public_path__ + "img/icon_customer_service_blue.d5159780.svg";